module.exports = __webpack_public_path__ + "static/img/car_bcg.44df8026.png";